import React, { Component } from 'react'
import "./hero2.css";
class Hero2 extends Component {
    render(){
        return (
            <div className='projects-hero'>
                <div className="heading">
                    <h1>{this.props.heading}</h1>
                    <p>{this.props.text}</p>
                </div>
            </div>
          )
    }
  
}

export default Hero2;